import './accordion.scss';
import React, { useState, memo, forwardRef, useImperativeHandle, useRef, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTheme } from '../themeProvider/ThemeProvider';
const Accordion = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    section,
    content,
    className,
    disabled,
    onClick,
    disabledAction,
    headerClassName,
    bodyClassName,
    bordered,
    onChange
  } = _ref;
  const {
    theme
  } = useTheme();
  const accordionBody = useRef();
  const [expandAccordion, setExpandAccordion] = useState(false);
  const [expandAccordionDone, setExpandAccordionDone] = useState(false);
  useImperativeHandle(ref, () => ({
    toggleAccordion(state, noAnimation) {
      toggleAccordion(state, noAnimation);
    },
    getExpandState() {
      return expandAccordion;
    }
  }));
  useEffect(() => {
    onChange(expandAccordion);
  }, [expandAccordion]);
  const toggleAccordion = (state, noAnimation) => {
    const {
      current
    } = accordionBody;
    if (current) {
      if (noAnimation) current.style.transition = 'none';
      current.style.maxHeight = `${current.scrollHeight}px`;
      setTimeout(() => {
        !state && (current.style.maxHeight = 0);
      });
      setExpandAccordion(state);
      !state && setExpandAccordionDone(state);
      setTimeout(() => {
        current.removeAttribute('style');
        setExpandAccordionDone(state);
      }, 200);
    }
    onClick && !expandAccordion && onClick();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('wrts-accordion', {
      disabled,
      bordered
    }, className, theme)
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('wrts-accordion-btn', headerClassName, {
      active: expandAccordion
    }),
    onClick: !disabled && !disabledAction ? () => toggleAccordion(!expandAccordion) : () => {}
  }, section), /*#__PURE__*/React.createElement("div", {
    ref: accordionBody,
    className: classNames('wrts-accordion-body', bodyClassName, {
      active: expandAccordionDone
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrts-accordion-content"
  }, content)));
});
Accordion.defaultProps = {
  onClick: () => {},
  onChange: () => {}
};
Accordion.propTypes = {
  section: PropTypes.object,
  content: PropTypes.object,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  disabledAction: PropTypes.bool,
  bordered: PropTypes.bool,
  headerClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  onChange: PropTypes.func
};
Accordion.displayName = 'Accordion';
export default /*#__PURE__*/memo(Accordion);